import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import {
  DevExtremeModule,
  DxAutocompleteModule,
  DxTextBoxModule,
} from 'devextreme-angular';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DemoInstructionComponent } from 'src/app/layout/logged-in-layout/demo-instruction/demo-instruction.component';
import { LoggedInHeaderComponent } from 'src/app/layout/logged-in-layout/logged-in-header/logged-in-header.component';
import { CampaignWallComponent } from '../components/campaign-wall/campaign-wall.component';
import { CommonNgoProfileComponent } from '../components/common-ngo-profile/common-ngo-profile.component';
import { CorporateVoucherDetailsComponent } from '../components/csr/corporate-voucher-details/corporate-voucher-details.component';
import { CsrCampaignDetailsComponent } from '../components/csr/csr-campaign-details/csr-campaign-details.component';
import { CsrDashboardComponent } from '../components/csr/csr-dashboard/csr-dashboard.component';
import { CsrInternalDonationsComponent } from '../components/csr/csr-internal-donations/csr-internal-donations.component';
import { CsrTaggedCampaignsComponent } from '../components/csr/csr-tagged-campaigns/csr-tagged-campaigns.component';
import { CsrTaggedNgosComponent } from '../components/csr/csr-tagged-ngos/csr-tagged-ngos.component';
import { DonorCrmDashboardComponent } from '../components/donor-crm/donor-crm-dashboard/donor-crm-dashboard.component';
import { DonorCrmInfoComponent } from '../components/donor-crm/donor-crm-info/donor-crm-info.component';
import { DonorManagementComponent } from '../components/donor-crm/donor-management/donor-management.component';
import { PricingComponent } from '../components/footer-components/pricing/pricing.component';
import { PrivacyPolicyComponent } from '../components/footer-components/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from '../components/footer-components/terms-and-conditions/terms-and-conditions.component';
import { HallOfFameComponent } from '../components/hall-of-fame/hall-of-fame.component';
import { NewsArticleCardsComponent } from '../components/news-article-cards/news-article-cards.component';
import { AnnouncementComponent } from '../components/ngo-campaign/announcement/announcement.component';
import { CampaignDetailsComponent } from '../components/ngo-campaign/campaign-details/campaign-details.component';
import { CampaignGalleryComponent } from '../components/ngo-campaign/campaign-gallery/campaign-gallery.component';
import { CampainSummaryComponent } from '../components/ngo-campaign/campain-summary/campain-summary.component';
import { DonationRequestsComponent } from '../components/ngo-campaign/donation-requests/donation-requests.component';
import { DonationSummarySharedComponent } from '../components/ngo-campaign/donation-summary-shared/donation-summary-shared.component';
import { DonorExperienceComponent } from '../components/ngo-campaign/donor-experience/donor-experience.component';
import { FundraisersListComponent } from '../components/ngo-campaign/fundraisers-list/fundraisers-list.component';
import { JoinAsFundraiserComponent } from '../components/ngo-campaign/join-as-fundraiser/join-as-fundraiser.component';
import { PasswordChangeComponent } from '../components/password-change/password-change.component';
import { ProceedToPaymentComponent } from '../components/proceed-to-payment/proceed-to-payment.component';
import { ReceiptsComponent } from '../components/receipts/receipts.component';
import { SlidingCampaignCardsComponent } from '../components/sliding-campaign-cards/sliding-campaign-cards.component';
import { FilterPipe } from '../pipe/custom-filter/filter.pipe';


// import { NullWithDefaultPipe } from '../pipe/null-with-default.pipe';

// function HttpLoaderFactory(http: HttpBackend) {
//   return new TranslateHttpLoader(new HttpClient(http));
// }

// const I18N_CONFIG = {
//   // defaultLanguage: 'english',
//   loader: {
//     provide: TranslateLoader,
//     useFactory: HttpLoaderFactory,
//     // deps: [HttpClient],
//     deps: [HttpBackend],
//   },
// };

@NgModule({
  imports: [
    DevExtremeModule,
    DxAutocompleteModule,
    RouterModule,
    CommonModule,
    DxTextBoxModule,
    FormsModule,
    PdfViewerModule,
    NgbCarouselModule
    // TranslateModule.forRoot(I18N_CONFIG),
  ],
  declarations: [
    NewsArticleCardsComponent,
    AnnouncementComponent,
    CampaignDetailsComponent,
    DonorExperienceComponent,
    FundraisersListComponent,
    JoinAsFundraiserComponent,
    CampainSummaryComponent,
    DonationSummarySharedComponent,
    TermsAndConditionsComponent,
    PrivacyPolicyComponent,
    PricingComponent,
    CampaignGalleryComponent,
    HallOfFameComponent,
    CampaignWallComponent,
    ReceiptsComponent,
    LoggedInHeaderComponent,
    ProceedToPaymentComponent,
    DonationRequestsComponent,
    DonorCrmDashboardComponent,
    DonorManagementComponent,
    DemoInstructionComponent,
    DonorCrmInfoComponent,
    PasswordChangeComponent,
    CsrTaggedCampaignsComponent,
    CsrTaggedNgosComponent,
    CsrInternalDonationsComponent,
    FilterPipe,
    CsrDashboardComponent,
    CsrCampaignDetailsComponent,
    CorporateVoucherDetailsComponent,
    CommonNgoProfileComponent,
    SlidingCampaignCardsComponent
  ],
  exports: [
    NewsArticleCardsComponent,
    AnnouncementComponent,
    CampaignDetailsComponent,
    DonorExperienceComponent,
    FundraisersListComponent,
    JoinAsFundraiserComponent,
    CampainSummaryComponent,
    DonationSummarySharedComponent,
    TermsAndConditionsComponent,
    PrivacyPolicyComponent,
    PricingComponent,
    CampaignGalleryComponent,
    HallOfFameComponent,
    CampaignWallComponent,
    ReceiptsComponent,
    LoggedInHeaderComponent,
    ProceedToPaymentComponent,
    DonationRequestsComponent,
    DonorCrmInfoComponent,
    PasswordChangeComponent,
    CsrTaggedCampaignsComponent,
    CsrTaggedNgosComponent,
    CsrInternalDonationsComponent,
    FilterPipe,
    CsrDashboardComponent,
    CsrCampaignDetailsComponent,
    CorporateVoucherDetailsComponent,
    CommonNgoProfileComponent,
    SlidingCampaignCardsComponent,
    NgbCarouselModule
  ],
})
export class SharedModule {}
